import { useQuery } from 'react-query'
import ApiSearchResponse from '@prismicio/client/types/ApiSearchResponse'
import { Prismic, prismicClient } from 'lib/prismic'

interface Params {
  id?: string
  uid?: string
  types?: string[]
  enabled?: boolean
}

export const useDocument = <Document>({ id, uid, types, enabled }: Params) => {
  if (!id && (!uid || !types || (types && !types.length))) {
    throw new Error('useDocument requires id or uid and at least 1 type to be defined.')
  }

  const { data, isLoading } = useQuery([id, uid, types], async () => {
    const requests: Array<Promise<ApiSearchResponse>> = []

    if (id) {
      const query = Prismic.Predicates.at('document.id', id ?? '')
      requests.push(prismicClient.query(query))
    } else {
      types?.forEach(type => {
        const query = Prismic.Predicates.at(`my.${type}.uid`, uid ?? '')
        requests.push(prismicClient.query(query))
      })
    }

    return Promise.all(requests).then(values => values.find(document => document.results.length))
  }, {
    enabled
  })

  return {
    loading: isLoading,
    document: data?.results?.[0] as unknown as Document | undefined
  }
}
